import styled from 'styled-components'
import MuiSelect from '@material-ui/core/Select'

const Select = styled(MuiSelect)`
  width: 100%;
`

export default Select
